import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-lc",
  "use": "icon-icon-lc-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-lc\">\n  <g fill-rule=\"evenodd\">\n    <path fill=\"#65cfff\" d=\"M0 0h512v512H0z\" />\n    <path fill=\"#fff\" d=\"m254.8 44.8 173.5 421.6-344 1L254.7 44.8z\" />\n    <path d=\"m255 103 150 362.6-297.5.8L255 103z\" />\n    <path fill=\"#ffce00\" d=\"m254.8 256.1 173.5 210.8-344 .5 170.5-211.3z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol